export default "__VITE_ASSET__B7Hic16v__";